const MONTHS = [
  "gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno",
  "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre",
];

export function formatDateLong(iso) {
  try {
    const d = new Date(iso);
    return `${String(d.getDate()).padStart(2, "0")} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
  } catch {
    return iso;
  }
}

export function formatDateShort(iso) {  try {
    const d = new Date(iso);
    return `${String(d.getDate()).padStart(2, "0")} / ${String(d.getMonth() + 1).padStart(2, "0")} / ${d.getFullYear()}`;
  } catch {
    return iso;
  }
}

export function isConcluded(iso) {
  try {
    const d = new Date(iso).getTime();
    return d + 24 * 60 * 60 * 1000 < Date.now();
  } catch {
    return false;
  }
}

export function formatRounds(rounds, reps) {
  if (rounds === null || rounds === undefined) return "—";
  return `${rounds}+${reps || 0}`;
}
